import React, {useEffect} from 'react';

function InputBasic({target, data, required, className, handler, placeholder,width}) {
    const inputStyle = {
        backgroundColor: required && (!data.data || (!data.data[target] && data.data[target] !== 0) || ('string' === typeof data.data[target] && data.data[target].trim() === '') || data.data[target] === '') ? '#ffe5e5' : '',
        border: required && (!data.data || (!data.data[target] && data.data[target] !== 0) ||  ('string' === typeof data.data[target] && data.data[target].trim() === '') || data.data[target] === '') ? '1px solid #e53939' : '',
        outline:'none',
        width: width ? width  : '100%'
    };

    const basicStyle = {
        width: width ? width  : '100%'

    };
    
    useEffect(() => {
        if(required){
            data.setData(prev => ({
                ...prev,
                required_validate: { ...prev?.required_validate, [target]: data.data && data.data[target] ? true : false }
            }));
        }

    }, [])

    const handleInputChange = (event) => {
        if(required){
            if ( event.target.value.trim() !== '') {
                data.setData(prev => ({
                    ...prev,
                    [target]: event.target.value,
                    required_validate: { ...prev.required_validate, [target]: true }
                }));
            } else {
                data.setData(prev => ({
                    ...prev,
                    [target]: event.target.value,
                    required_validate: { ...prev.required_validate, [target]: false }
                }));
            }
        }else{
            data.setData(prev => ({
                ...prev,
                [target]: event.target.value
            }));
        }

        if(handler) handler(event.target.value);

    };


    return (
        <input
            type={"text"}
            className={`basic-input focus ${className ? className : ""}`}
            value={!data.data || (!data.data[target] && data.data[target] !== 0) ? '' : data.data[target]}
            onChange={handleInputChange}
            placeholder={!placeholder || (!placeholder && placeholder !==0) ? '' : placeholder}
            style={required ? inputStyle : basicStyle}
            maxLength={255}
        />
    );
}

export default InputBasic;